import React from 'react';
import { ModalWrapper } from '../modals/ModalWrapper';
import { Communication } from '../../services/communicationService';
import { formatDateTime } from '../../utils/dateUtils';
import CommunicationAttachmentList from './CommunicationAttachmentList';

interface Props {
  comm: Communication | null;
  onClose: () => void;
  userTimezone: string;
}

const Row: React.FC<{ label: string; value?: string | null }> = ({ label, value }) =>
  value ? (
    <div className="flex gap-2 text-xs">
      <span className="text-gray-500 w-20 shrink-0">{label}</span>
      <span className="text-gray-800 break-all">{value}</span>
    </div>
  ) : null;

const CommunicationDetailModal: React.FC<Props> = ({ comm, onClose, userTimezone }) => {
  if (!comm) return null;
  const when = formatDateTime(comm.received_at || comm.created_at, {}, userTimezone);

  return (
    <ModalWrapper
      isOpen={!!comm}
      onClose={onClose}
      title={comm.channel === 'EMAIL' ? comm.subject || 'Message' : 'SMS message'}
      width="max-w-2xl"
      titleAlign="left"
      titleClassName="text-lg font-bold text-[#366A75] leading-tight"
    >
      <div className="space-y-3">
        <div className="space-y-1 rounded-lg bg-gray-50 border border-gray-200 px-3 py-2">
          <Row label="From" value={comm.from_address} />
          <Row label="To" value={comm.to_address} />
          <Row label="Channel" value={comm.channel} />
          <Row label="Direction" value={comm.direction} />
          <Row label="Status" value={comm.status} />
          <Row label="When" value={when} />
        </div>
        {/* Above the body: what came with the message is the first thing
            somebody opening it looks for, and a long email would bury it. */}
        <CommunicationAttachmentList comm={comm} />
        {comm.body_html ? (
          <div
            className="max-h-[60vh] overflow-y-auto rounded-lg bg-[#EBF5F5] border border-[#B4D9D4] px-4 py-2 text-sm break-words"
            dangerouslySetInnerHTML={{ __html: comm.body_html }}
          />
        ) : (
          <div className="max-h-[60vh] overflow-y-auto rounded-lg bg-gray-50 border border-gray-200 px-4 py-2 text-sm whitespace-pre-wrap break-words">
            {comm.body_text || '(empty)'}
          </div>
        )}
      </div>
    </ModalWrapper>
  );
};

export default CommunicationDetailModal;
